import {
  isKeyboardSubAppMusicRhythmEnabled,
  resolveKeyboardSubAppRhythmDeviceId,
  supportsKeyboardSubAppMusicRhythm,
} from "./keyboardSubAppMusicRhythm";

const GLOBAL_RHYTHM_ENABLED_KEY = "music-management:musicRhythm:enabled";
const GLOBAL_RHYTHM_CAPTURE_KEY = "music-management:musicRhythm:captureActive";
const GLOBAL_RHYTHM_SELECTED_IDS_KEY =
  "music-management:selectedRhythmDeviceIds";
const KEYBOARD_RHYTHM_CAPTURE_KEY =
  "keyboard-management:musicRhythm:captureActive";

/** 桌面端退出前是否需由主应用恢复全局音乐律动下的常规灯效 */
export function isGlobalMusicRhythmQuitRestoreNeeded(payload?: {
  rhythmActive?: boolean;
}): boolean {
  if (payload?.rhythmActive === true) return true;
  if (typeof window === "undefined") return false;
  try {
    if (window.sessionStorage.getItem(GLOBAL_RHYTHM_CAPTURE_KEY) === "1") {
      return true;
    }
    if (window.localStorage.getItem(GLOBAL_RHYTHM_ENABLED_KEY) !== "1") {
      return false;
    }
    const raw = window.sessionStorage.getItem(GLOBAL_RHYTHM_SELECTED_IDS_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) && parsed.length > 0;
  } catch {
    return false;
  }
}

/**
 * 键盘子应用内退出桌面端时由子应用恢复并 ack：
 * - 全局音乐律动：走灯光页「是」同款链路（handleGlobalRhythmQuitRestore）
 * - V1 本地律动（M98 / X75 Pro / X75 Pro Screen · 2.4G）
 */
export function shouldKeyboardSubAppOwnElectronBeforeQuit(payload?: {
  rhythmActive?: boolean;
}): boolean {
  if (typeof window === "undefined") return false;
  if (!window.location.pathname.startsWith("/keyboard-management")) {
    return false;
  }
  if (isGlobalMusicRhythmQuitRestoreNeeded(payload)) {
    return true;
  }
  try {
    const raw = window.localStorage.getItem("equipmentData");
    const eq = raw ? JSON.parse(raw) : null;
    if (!supportsKeyboardSubAppMusicRhythm(eq)) {
      return false;
    }
    if (window.sessionStorage.getItem(KEYBOARD_RHYTHM_CAPTURE_KEY) === "1") {
      return true;
    }
    const deviceId = resolveKeyboardSubAppRhythmDeviceId(eq);
    return isKeyboardSubAppMusicRhythmEnabled(deviceId);
  } catch {
    return false;
  }
}
